
<div class="k-d-flex k-justify-content-between k-gap-md m-b-4 fit-content-width">
    <kendo-label text="From Date">
        <kendo-datepicker
            adaptiveMode="auto"
            [size]="'small'"
            [(ngModel)]="fromDate"
            (ngModelChange)="setDefaultState()"
        ></kendo-datepicker>
        </kendo-label>
        
        <kendo-label text="Thru Date">
        <kendo-datepicker
            adaptiveMode="auto"
            [size]="'small'"
            [(ngModel)]="thruDate"
            (ngModelChange)="setDefaultState()"
        ></kendo-datepicker>
    </kendo-label>

    <kendo-label text="Tier">
      <kendo-dropdownlist
          [data]="tiers"
          [(ngModel)]="selectedTier"
          textField="name"
          valueField="id"
          (ngModelChange)="setDefaultState()"
        ></kendo-dropdownlist>
    </kendo-label>

    <kendo-label text="Type">
     <kendo-multiselect
          placeholder="Select changeset type(s)"
          [data]="types"
          [(ngModel)]="selectedTypes"
          textField="name"
          valueField="id"
          (ngModelChange)="setDefaultState()"
        ></kendo-multiselect>
    </kendo-label>

    <app-item-filter
        class="content-align-end"
        label="Filter Items"
        [preselected]="selectedItemIds"
        (selectionChanged)="onItemFilterChanged($event)"
    ></app-item-filter>

    <div  class="content-align-end">
        <button kendoButton (click)="setDefaultState()" rounded="full" fillMode="outline" themeColor="primary">
            <fa-icon [icon]="['fas', 'rotate-right']"></fa-icon>
        </button>
    </div>
</div>

<app-data-grid
  [dataItems]="changesetSummary"
  [columns]="columns"
  [fontSize]="fontSize"
  [state]="state"
  [filterable]="'menu'"
  (dataStateChange)="onDataStateChanged($event)"
  (filterChange)="filterChanged($event)"
  [group]="group"
>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="tierName"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [extraParams]="distinctParams"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="submittedBy"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [extraParams]="distinctParams"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

<ng-template
    groupColumnHeaderTemplate
    field="transactionDate"
    let-group="group"
    let-column="column"
  >
    <div class="k-d-flex k-gap-md k-justify-content-between">
      <span>{{ group.value | date: "MM/dd/yyyy" : "+0000" }} <span class="xsmall-text text-opacity-50"> {{group.items.length}} sync(s)  &middot; <span class="text-warning xsmall-text">{{getTotal(group, 'pendingCount')}} pending</span> &middot;<span class=" text-danger xsmall-text"> {{getTotal(group, 'failedCount')}} failed </span></span> </span>
    </div>
  </ng-template>


    
  <ng-template
    columnTemplate
    field="syncType"
    let-row="row"
    let-column="column"
  >
    <kendo-chip *ngFor="let type of row.syncType" rounded="full">{{type}}</kendo-chip>
  </ng-template>


    <ng-template
    columnTemplate
    field="pendingCount"
    let-row="row"
    let-column="column"
  >
    <div [style.textAlign]="'center'">
      <kendo-chip *ngIf="row.pendingCount > 0" themeColor="warning" rounded="medium"
        (click)="navigateToDetails(row, 'pending')"
        >{{row.pendingCount}}&nbsp; <fa-icon
            class="m-r-0"
            [icon]="['fas', 'chevron-right']"
            size="sm"
          ></fa-icon></kendo-chip>
      <span *ngIf="row.pendingCount === 0"> 
        <app-column
            [fontSize]="fontSize"
            [column]="column"
            [data]="row"
        ></app-column></span>
    </div>
</ng-template>


    <ng-template
    columnTemplate
    field="failedCount"
    let-row="row"
    let-column="column"
  >
    <div [style.textAlign]="'center'">
    <kendo-chip *ngIf="row.failedCount > 0" themeColor="error" rounded="medium"
      (click)="navigateToDetails(row, 'failed')"
      >{{row.failedCount}}&nbsp; <fa-icon
            class="m-r-0"
            [icon]="['fas', 'chevron-right']"
            size="sm"
          ></fa-icon></kendo-chip>
    <span *ngIf="row.failedCount === 0"> 
        <app-column
            [fontSize]="fontSize"
            [column]="column"
            [data]="row"
        ></app-column></span>
    </div>
</ng-template>



<ng-template
    columnTemplate
    field="successCount"
    let-row="row"
    let-column="column"
  >
  <div [style.textAlign]="'center'">
      <kendo-chip *ngIf="row.successCount > 0" themeColor="success" rounded="medium"
        (click)="navigateToDetails(row, 'success')"
        >{{row.successCount}}&nbsp; <fa-icon
            class="m-r-0"
            [icon]="['fas', 'chevron-right']"
            size="sm"
          ></fa-icon></kendo-chip>
      <span *ngIf="row.successCount === 0"> 
        <app-column
            [fontSize]="fontSize"
            [column]="column"
            [data]="row"
        ></app-column></span>
  </div>
</ng-template>


    <ng-template
    columnTemplate
    field="canceledCount"
    let-row="row"
    let-column="column"
  >
    <div [style.textAlign]="'center'">
      <kendo-chip  *ngIf="row.canceledCount > 0" themeColor="error" rounded="medium"
        (click)="navigateToDetails(row, 'canceled')"
        >{{row.canceledCount}}&nbsp; <fa-icon
            class="m-r-0"
            [icon]="['fas', 'chevron-right']"
            size="sm"
          ></fa-icon></kendo-chip>
      <span *ngIf="row.canceledCount === 0" > 
        <app-column
            [fontSize]="fontSize"
            [column]="column"
            [data]="row"
        ></app-column></span>
    </div>
</ng-template>

  <ng-template
    columnTemplate
    field="viewDetails"
    let-row="row"
    let-column="column"
  >
    <a
      class="view-details-link"
      (click)="navigateToDetails(row)"
    >
      View Details >
    </a>
  </ng-template>

</app-data-grid>